import { getContentDispositionFileName } from '../utils/axios';
export var useFileDownload = function useFileDownload() {
  var downloadFileWithUrl = function downloadFileWithUrl(url) {
    var el = document.createElement('a');
    el.href = url;
    el.download = '';
    el.style.display = 'none';
    document.body.appendChild(el);
    el.click();
    document.body.removeChild(el);
  }; // Download the blob file


  var downloadBlobFile = function downloadBlobFile(response, config) {
    if (!response || !(response !== null && response !== void 0 && response.data)) return; // Create blob

    var blob = new Blob([response.data], {
      type: (config === null || config === void 0 ? void 0 : config.type) || 'application/pdf'
    });
    var url = window.URL.createObjectURL(blob); // Create a element

    var link = document.createElement('a');
    link.href = url; // Get file name

    var filename = getContentDispositionFileName(response.headers['content-disposition']);
    link.download = filename || 'example.pdf'; // Click download

    document.body.appendChild(link);
    link.click(); // Clean

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return {
    downloadFileWithUrl: downloadFileWithUrl,
    downloadBlobFile: downloadBlobFile
  };
};